function WalletManagement() {
  let walletManagement = [
    {
      name: "Wallet Management",
      icon: "Wallet Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "prepaidcard",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/wallet-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const walletDashboard = () => {
    const walletDashboard = [
      {
        path: "/index/wallet-dashboard",
        name: "Account Dashboard",
        icon: "Wallet Dashboard",
        logoName: "wallet dashboard",
        flag: "WALLET DASHBOARD",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return walletDashboard;
    // } else {
    //   return "";
    // }
  };

  const walletTransaction = () => {
    const profileArr = [
      {
        path: "/index/wallet-transaction",
        name: "Transaction",
        icon: "Wallet Transaction",
        logoName: "wallet transaction",
        flag: "WALLET TRANSACTION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const operationLogs = () => {
    const mybanksArr = [
      {
        path: "/index/operation-logs",
        name: "Fee Transaction",
        icon: "Operation Logs",
        logoName: "FEE RECEIVED",
        flag: "OPERATION LOGS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const refundPartner = () => {
    const profileArrs = [
      {
        path: "/index/Refund",
        name: "Refund",
        icon: "fee-master",
        logoName: "RECEIVED",
        flag: "REFUND",
      },
    ];
    return profileArrs;
  };

  const loyalPoints = () => {
    const mycardsArr = [
      {
        path: "/index/loyal-points",
        name: "Loyalty Points",
        icon: "Loyalty Points",
        logoName: "loyalty points",
        flag: "LOYALTY POINTS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const feeReport = () => {
    const mycardsArr = [
      {
        path: "/index/fee-report",
        name: "Fee Report",
        icon: "Fee Report",
        logoName: "fee report",
        flag: "FEE REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const summaryReport = () => {
    const mycardsArr = [
      {
        path: "/index/summary-report",
        name: "Summary Report",
        icon: "Summary Report",
        logoName: "summary report1",
        flag: "SUMMARY REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const settlementReport = () => {
    const mycardsArr = [
      {
        path: "/index/settlement-report",
        name: "Settlement Report",
        icon: "Settlement Report",
        logoName: "summary report1",
        flag: "SETTLEMENT REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

   const Chargeback = () => {
    const mycardsArr = [
      {
        path: "/index/chargeback",
        name: "Chargeback",
        icon: "ChargeBack",
        logoName: "chargeback",
        flag: "CHARGEBACK",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const Reconciliation = () => {
    const reconciliation = [
      {
        path: "/index/reconciliation",
        name: "Reconciliation",
        icon: "reconciliation",
        logoName: "reconciliation",
        flag: "RECONCILIATION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return reconciliation;
    // } else {
    //   return "";
    // }
  };
  

  let a = dashboard();
  let b = walletDashboard();
  let c = walletTransaction();
  let d = operationLogs();
  let e = loyalPoints();
  let f = feeReport();
  let g = summaryReport();
  let h = refundPartner();
  let i = settlementReport();
  let j = Chargeback();
  let k = Reconciliation();

  walletManagement[0].items = [
    ...a,
    ...b,
    ...c,
    ...d,
    ...h,
    ...f,
    ...g,
    ...e,
    ...i,
    ...j,
    ...k,
  ];

  return walletManagement;
}

export default WalletManagement;
